<template>
  <div>
    <div v-if="element.widgetName=='qr'" v-show="false">
      {{ isQrOkay }}
    </div>
    <el-dialog
        :visible.sync="dialogVisible"

        width="30%"
        class="edit-dialog-mobile"
        :before-close="handleClose">
      <div id="moein">
      <span>
                <WidgetsConfigHandler @changeConfig="changeConfig" :element="element" :widget-name="widgetName"/>
      </span>
        <span slot="footer" class="dialog-footer">
  </span>
      </div>
    </el-dialog>
    <Moveable
        class="moveable"
        ref="moveable"
        v-bind="moveable"
        :style="getFloatWidgetStyle"
        @drag="handleDrag"
        @resize="handleResize"
        @rotate="handleRotate"
    >
      <!--      <div @touchstart="deleteWidget">-->
      <!--        salam-->
      <!--      </div>-->
      <!--      <span @keydown.left="widgetMove" @click="widgetClicked">-->

      <WidgetsHandler :element="element" :config="element.config" :widgetName="widgetName"/>

      <!--      </span>-->

    </Moveable>


    <div ref="handlerRow" class="abs"
         v-if="!isPreview"
         style="height: 1px!important;z-index: 2002!important;"
         :style="getFloatWidgetHandlerStyle"
    >
      <el-button v-if="!notInPrint" @click="editWidget" size="mini" class="abs widget-button"
                 style="z-index: 2;"
                 icon="el-icon-edit"/>
      <el-button v-if="!notInPrint &&element.widgetName!='qr'" @click="deleteWidget"
                 style="right: 0px;padding: 5px;z-index: 2" size="mini"
                 class="abs widget-button"
                 icon="el-icon-delete-solid"/>
      <el-button v-if="isQrOkay&&!notInPrint && element.widgetName=='qr'" style="right: 0px;padding: 5px" size="mini"
                 class="abs widget-button"
                 icon="el-icon-success">
        <span style="color: #4cdeab">معتبر</span>
      </el-button>

      <el-button v-if="!isQrOkay&&!notInPrint && element.widgetName=='qr'" style="right: 0px;padding: 5px" size="mini"
                 class="abs widget-button"
                 icon="el-icon-error">
        <span style="color: red">نامعتبر</span>
      </el-button>
    </div>
  </div>

</template>

<script>

import Moveable from 'vue-moveable';
import WidgetsHandler from "@/components/WidgetsHandler";
import WidgetsConfigHandler from "@/components/WidgetsConfigHandler";

export default {
  name: 'MoveableComponent',
  props: {
    element: {},
    index: {},
    widgetName: {},
    notInPrint: {},
    isPreview:{}
  },
  components: {
    WidgetsConfigHandler,
    WidgetsHandler,
    Moveable,
  },
  computed: {
    isQrOkay() {
      if (this.element.widgetName != 'qr') return false
      let width = this.element.width ? this.element.width : 200
      let height = this.element.height ? this.element.height : parseInt(this.heightComputed)
      if (width > 70 && height > 70 && 0.75 < width / height && width / height < 1.66666) {
        return true
      } else {
        this.check()
        return false
      }
    },
    getFloatWidgetStyle() {

      if (this.element.widgetName == 'qr') {
        return {
          width: this.element.width ? this.element.width + 'px' : '200px',
          height: this.element.height ? this.element.height + 'px' : this.heightComputed,
          transform: this.element.transform,
          zIndex: 2001
        }
      }
      return {
        width: this.element.width ? this.element.width + 'px' : '200px',
        height: this.element.height ? this.element.height + 'px' : this.heightComputed,
        transform: this.element.transform,
        zIndex: this.element.config.zIndex ? this.element.config.zIndex : ''
      }
    },
    getFloatWidgetHandlerStyle() {
      return {
        width: this.element.width ? this.element.width + 'px' : '200px',
        // height: this.element.height ? this.element.height + 'px' : this.heightComputed,
        transform: this.element.transform
      }
    },
    heightComputed() {
      if (this.widgetName == 'image') return '200px'
      if (this.widgetName == 'qr') return '200px'
      if (this.widgetName == 'text') return '35px'
      return false
    }
  },
  data() {
    return {
      dialogVisible: false,
      lastTime: null,
      lastTimeTransform: null,
      lastTimeResize: null,
      transform: null,
      width: null,
      height: null,
      moveable: {
        draggable: true,
        throttleDrag: 0,
        resizable: true,
        throttleResize: 1,
        keepRatio: false,
        scalable: false,
        throttleScale: 0,
        rotatable: true,
        throttleRotate: 0,
        pinchable: ["draggable", "resizable",'rotatable'], // ["draggable", "resizable", "scalable", "rotatable"]
        origin: false,
        renderDirections: ['s', 'se', 'e'],
        deg: 0
      }
    }
  },

  methods: {
    editWidget() {
      this.dialogVisible = true
    },
    check() {
      if (this.lastTime + 5000 >= Date.now()) return
      this.lastTime = Date.now()
      this.$notify.warning({
        title: "هشدار",
        message: 'QR کد شما از حالت مربع و با کیفیت خارج شده است.',
        offset: 100,
        duration: 5000
      });
    },
    changeConfig(data) {
      this.$emit('changeConfig', data)
      if (data.props == 'image' || data.props == 'url' || data.props == 'content') {
        this.handleClose()
      }
    },
    widgetClicked() {
      this.$emit('setActiveWidget', this.element.id, this.index)
    },
    handleClose() {
      this.dialogVisible = false
    },
    deleteWidget() {
      this.$emit('deleteWidgetEmit', this.element.id)
    },
    handleDrag({target, transform}) {
      target.style.transform = transform;
      this.$refs.handlerRow.style.transform = transform;
      this.transform = transform
      if (!(this.lastTimeTransform + 200 >= Date.now())) {
        this.lastTimeTransform = Date.now()
        this.sendDrag()
      }
      // let temp = _.debounce(this.sendDrag, 700)
      // temp()
    },
    sendDrag() {
      let moveables = document.getElementsByClassName('moveable-control-box')
      console.log(moveables, 'moveables')
      if (moveables && moveables.length && moveables[this.index].style.display == 'none') {
        moveables[this.index].style.display = 'block'
      }
      this.$emit('changePosition', 'transform', this.transform, this.element.id)
      // setTimeout(() => this.transform = null, 3000)
    },
    sendResize() {
      let moveables = document.getElementsByClassName('moveable-control-box')
      if (moveables && moveables.length && moveables[this.index].style.display == 'none') {
        moveables[this.index].style.display = 'block'
      }
      this.$emit('changePosition', 'width', this.width, this.element.id)
      this.$emit('changePosition', 'height', this.height, this.element.id)
    },
    handleResize({target, width, height, delta,}) {
      delta[0] && (target.style.width = `${width}px`);
      delta[1] && (target.style.height = `${height}px`);
      delta[0] && (this.$refs.handlerRow.style.width = `${width}px`);
      this.width = width
      this.height = height
      if (!(this.lastTimeResize + 200 >= Date.now())) {
        this.lastTimeResize = Date.now()
        this.sendResize()
      }
    },
    handleRotate({target, transform}) {
      target.style.transform = transform;
      this.$refs.handlerRow.style.transform = transform;
      this.transform = transform
      if (!(this.lastTimeTransform + 50 >= Date.now())) {
        this.lastTimeTransform = Date.now()
        this.sendDrag()
      }
    },
  },
  watch: {
    dialogVisible(val) {
      this.$emit('changeScale', val)
    }
  }
}
</script>

<style>
.moveable {
  z-index: 999;
  position: absolute;
  cursor: grab;
}

</style>
